<template>
  <div id="app">
        <van-skeleton :row="10" row-width="100%"  style="margin-bottom: 10px;" :loading="loading">
            <template v-if="data.length > 0">
                <div class="icon-wrap">
                    <img src="../../assets/success.svg">
                </div>
                <p class="patch-count">
                  {{ _('扫码成功') }}
                </p>
                <van-list>
                    <template v-for="(item, index) in data">
                        <div :key="index">
                            <van-cell  :value="checkResultFilter(item.checkResult)" :value-class="item.checkResult | getTypeClass" title-width="100%">
                                <template #title>
                                    <span class="index">{{index + 1}}</span>
                                    <span class="patch-name">{{item.name}}</span>
                                </template>
                            </van-cell>
                        </div>
                    </template>
                </van-list>
            </template>
            <div v-else class="empty-container">
                <img src="../../assets/empty.svg" class="empty-img"/>
                <p>{{_('暂无数据')}}</p>
            </div>
        </van-skeleton>
  </div>
</template>

<script>

export default {
    name: 'App',
    props: {
        infoData: {
            type: Object,
            default: function () {
              return {};
            }
        }
    },
    data () {
        return {
            loading: false
        };
    },
    computed: {
        data(){
            return this.infoData.code === 0 ? this.infoData.data.pkgList : [];
        }
    },
    filters: {
        getTypeClass (v) {
            return v === 0 ? 'success' : 'fail';
        }
    },
    methods: {
        checkResultFilter (v) {
            let CHECK_RESULT_FILTER = {
                0: this._('校验成功'),
                1: this._('该包不是平台发布的包'),
                2: this._('该包已下架'),
                3: this._('设备不支持升级')
            };
            return CHECK_RESULT_FILTER[v] || '-';
        },
    }
}
</script>

<style scoped lang="stylus">
#app
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding-top 15px
  >>> .van-skeleton__row:not(:first-child)
    width 100% !important

.icon-wrap
    padding: 30px 0 35px 0
    text-align: center

.icon-wrap > img
    width: 88px
    height: 88px



.patch-count
    font-size: 18px
    line-height: 1.5
    width: 90%
    margin: 0 auto
    text-align: center

.patch-count > span
    font-size: 13px
.index
    margin-right 20px
.empty-container
    text-align center
    font-size 18px
    padding: 45px 0 35px 0
    color #ccc
.empty-img
    width 88px
    height 88px
.success
    color #0d9e2c
.fail
    color #de1b1b
</style>
